// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("../../../node_modules/@pmmmwh/react-refresh-webpack-plugin/client/ReactRefreshEntry.js");
var __webpack_exports__ = __webpack_require__("./index.js");
